import React from 'react';

interface QuoteProps {
  quote: string;
  author: string;
}

const Quote: React.FC<QuoteProps> = ({ quote, author }) => {
  return (
    <div className="bg-transparent border-t border-b border-steel-blue py-8 my-8 text-center">
      <h2 className="text-2xl mb-4 text-off-white">Quote of the Day</h2>
      <figure className="max-w-3xl mx-auto">
        <blockquote className="text-xl italic font-semibold text-off-white">
          <p>"{quote}"</p>
        </blockquote>
        <figcaption className="mt-4 text-light-blue">
          - {author}
        </figcaption>
      </figure>
    </div>
  );
};

export default Quote;